import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

// Fonts
import './fonts/korinna.ttf'
import './fonts/Swiss921-BT_43276.ttf'

ReactDOM.render(<App />, document.getElementById('root'));